<template>
    <div class="time-zone">
        <el-select :value="zone" placeholder="Please choose" @change="changeTimeZone" style="width: 170px;" size="mini">
            <el-option label="Time Zone - Shanghai" value="Asia/Shanghai">Time Zone - Shanghai</el-option>
            <el-option label="Time Zone - UTC" value="UTC">Time Zone - UTC</el-option>
        </el-select>
        <el-date-picker
            size="mini"
            class="ml6"
            v-model="range"
            type="daterange"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="To"
            start-placeholder="Start Date"
            end-placeholder="End Date"
            :picker-options="pickerOptions"
            @change="changeRangeTime"
            :clearable="false"
            :editable="false"
            style="width: 220px;">
        </el-date-picker>
        <el-button type="primary" size="mini" class="ml10" @click="handleClick" :loading="addLoading" v-if="pageFuncNames.includes('add_ad')">Create Ad</el-button>
    </div>
</template>

<script>
    import dateShortcuts from './dateShortcuts.js';

    export default {
        name: "TimeZone",
        props:{
            zone:String,
            rangeTime:Array,
            pageFuncNames:Array,
            addLoading:Boolean,
        },
        data(){
            return {
                range:[],
                pickerOptions:{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        dateShortcuts.today,
                        dateShortcuts.yesterday,
                        dateShortcuts.last7,
                        dateShortcuts.last14,
                        dateShortcuts.last30,
                        dateShortcuts.thisWeek,
                        dateShortcuts.thisMonth,
                        dateShortcuts.thisQuarter,
                    ],
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                },
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.range = [...this.rangeTime];
            })

        },
        methods:{
            handleClick(){
                this.$emit('click-add');
            },
            changeTimeZone(val){
                this.$emit('change',val,this.range);
                console.log('changeTimeZone',val);
                this.$store.commit('apple/SET_TIME_ZONE',val);
            },
            changeRangeTime(range){
                console.log('change time',range);
                this.$emit('change',this.zone,this.range);
            },

        }
    }
</script>

<style lang="scss" scoped>
  
</style>
